export const CLOSED_STORE_MESSAGE = "⚠️ We are closed.";
export const OPEN_STORE_MESSAGE = "🕓 Open now";
export const BREAK_MESSAGE = "We're on a break. We'll be back soon!";
export const ORDERS_ON_HOLD_MESSAGE =
  "💡 Orders are on hold, kindly check later";
export const STAFF_MESSAGE = "Looking good! You are a staff member.";

export const VALIDATION_MESSAGES = {
  NO_ITEMS: "Kindly Select Items",
  NO_TAKEAWAY_TIME: "Kindly Select Takeaway Time",
  NO_PICKUP_TIME: "Kindly Select Pickup Time",
  NO_DELIVERY_TIME: "Kindly Select Delivery Time",
  NO_TABLE: "Kindly Select Table",
  NO_ADDRESS: "Kindly Select Address",
  ON_HOLD: "Orders are on hold, kindly check later",
  DELIVERY_DISABLED: "Delivery is disabled",
  TAKEAWAY_DISABLED: "Takeaway is disabled",
  PICKUP_DISABLED: "Pickup is disabled",
  DINE_IN_DISABLED: "Dine-in is disabled",
  TIME_IN_VALID: "Kindly re-select the time",
  LOCATION_PERMISSION_DENIED: "Permission Denied! Please enable geolocation",
  FAR_FROM_STORE: "You seem to be too far from the restaurant.",
  NO_PLATFORM: "Kindly select a platform",
} as const;

/**
 * The original's generic "a request on this page failed" snackbar copy —
 * verbatim from `live-app-formatted.js` (the delivery-address flow's own
 * catch), **including its misspelling of "occurred"**. Do not correct it.
 *
 * Raised with `severity: "error"` and `anchorOrigin: { vertical: "top",
 * horizontal: "center" }`, which is the pairing every one of the original's
 * fetch-failure snackbars uses.
 */
export const GENERIC_REQUEST_FAILED_MESSAGE =
  "An error occured. Please try again later.";

/** The menu page's catalog load. Same string; named for its call site. */
export const CATALOG_LOAD_FAILED_MESSAGE = GENERIC_REQUEST_FAILED_MESSAGE;

/**
 * The menu body's delivery prompt — verbatim from `iF`'s mount effect in
 * `live-chunks/fmt_584-…js`, raised alongside `openModal(DELIVERY_INFO_MODAL)`
 * with `severity: "warning"` and a top/centre anchor.
 */
export const ENTER_DELIVERY_INFORMATION_MESSAGE = "Enter delivery information";

/**
 * `/orders/[id]` — verbatim from the original order page's own catch
 * (`fmt_pages_orders_id.js`).
 */
export const ORDER_FETCH_FAILED_MESSAGE =
  "Unable to fetch order details. Please try again later.";

/**
 * `/customer-form` — verbatim from the original customer-form chunk's submit
 * failure.
 */
export const CUSTOMER_FORM_SUBMIT_FAILED_MESSAGE =
  "Couldn't submit at this time. Please try again later.";
